"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.deserializeYyyyMm = exports.serializeYyyyMm = exports.deserializeYyyyMmDate = exports.serializeYyyyMmDate = void 0;
const dto_1 = require("@flexidao/dto");
const d = __importStar(require("schemawax"));
const schemawax_1 = require("schemawax");
const parsers_1 = require("../../parsers");
const yyyyMmDateDecoder = d.string.andThen((s) => {
    let decodedValue;
    try {
        decodedValue = decodeURIComponent(s);
    }
    catch (e) {
        throw new schemawax_1.DecoderError("Invalid URI encoding");
    }
    if (decodedValue === null) {
        throw new schemawax_1.DecoderError("No yyyy-mm was provided");
    }
    const date = (0, parsers_1.yyyyMMParser)(decodedValue);
    if (isNaN(date.getTime())) {
        throw new schemawax_1.DecoderError(`Invalid date provided '${decodedValue}'`);
    }
    return date;
});
const serializeYyyyMmDate = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    return `${year}-${month.toString().padStart(2, "0")}`;
};
exports.serializeYyyyMmDate = serializeYyyyMmDate;
const deserializeYyyyMmDate = (s) => yyyyMmDateDecoder.forceDecode(s);
exports.deserializeYyyyMmDate = deserializeYyyyMmDate;
const serializeYyyyMm = (month) => month;
exports.serializeYyyyMm = serializeYyyyMm;
const deserializeYyyyMm = (s) => {
    if ((0, dto_1.validateYyyyMm)(s)) {
        return s;
    }
    throw new Error(`Invalid month: '${s}' should be on the format 'yyyy-MM'`);
};
exports.deserializeYyyyMm = deserializeYyyyMm;
//# sourceMappingURL=yyyy-mm.js.map